import React from "react";
import { Outlet } from "react-router-dom";
import StoreHeader from "../../components/store/Header";
import CartDrawer from "../../components/store/CartDrawer";
import SiteFooter from "../../components/SiteFooter";

const StoreLayout: React.FC = () => {
    return (
        <div className="min-h-screen bg-midnight-900 text-white">
            <StoreHeader />
            <main className="pt-28 pb-16 px-4 lg:px-10">
                <div className="mx-auto max-w-6xl">
                    <Outlet />
                </div>
            </main>
            <SiteFooter />
            <CartDrawer />
        </div>
    );
};

export default StoreLayout;
